import { computed, inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { EventSummary, ExperienceFuncData } from '@interfaces';
import { AppService, FuncService, TrimesterService } from '../../services';

@Injectable({ providedIn: 'root' })
export class ExperienceAreaService {

	private func = inject(FuncService);
	private app = inject(AppService);
	private trimesterService = inject(TrimesterService);
	public readonly experienceData = signal<ExperienceFuncData | undefined>(undefined);

	public readonly canEdit = computed(() => this.app.data().permissions.canEditAccSchedules);

	constructor() {
		toObservable(this.trimesterService.selectedTrimester).subscribe(async (selectedTrimester) => {
			if (selectedTrimester) await this.reloadData();
		});
	}

	public async reloadData() {
		const trimesterId = this.trimesterService.selectedTrimester()?.trimesterId;
		//Should never happen, but just in case.
		//This is a safety check to ensure that the experience data is only loaded when a trimester is selected.
		//If no trimester is selected, the experience data will not be loaded
		//and the service will not be able to provide any data.
		if (trimesterId) {
			const data = await this.func.experience.getData({ trimesterId });
			this.experienceData.set(data);
		}
	}

	public async loadExperienceData() {
		if (!this.experienceData()) await this.reloadData();
	}

	async addEngagementIdToContactRequest(contactRequestId: number, engagementId: number) {
		await this.func.contactRequest.addEngagementId({ contactRequestId, engagementId });
	}

	async generateAccClassEvents(accId: number): Promise<EventSummary[] | undefined> {
		return await this.func.experience.generateAccClassEvents({ accId });
	}
}